// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"91ec7004","504":"9acbbc16"}[chunkId] + ".chunk.js";
};